import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const PHASES = [
    "Cross-checking realistic budgets…",
    "Curating hand-picked hotels…",
    "Picking standout restaurants…",
    "Selecting must-do experiences…",
    "Drafting your day-by-day plan…",
];

const PhaseTicker = ({ destination }) => {
    const [i, setI] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setI((c) => (c + 1) % PHASES.length), 1800);
        return () => clearInterval(id);
    }, []);
    return (
        <span className="text-sm text-ink">
            <b className="text-terracotta">{destination || "Your trip"}:</b> {PHASES[i]}
        </span>
    );
};

export const ExploreSkeleton = ({ destination }) => (
    <div className="mx-auto mt-16 max-w-6xl px-6" data-testid="explore-loading">
        <div data-testid="explore-skeleton" />
        <span className="overline">your trip to</span>
        <div className="mt-2 h-14 w-2/3 animate-pulse rounded-2xl bg-ink/10" />
        <div className="mt-5 h-5 w-1/2 animate-pulse rounded-full bg-ink/10" />
        <div className="mt-6 flex flex-wrap gap-3">
            {[60, 80, 70, 90].map((w, i) => (
                <div key={i} style={{ width: `${w}px` }} className="h-7 animate-pulse rounded-full bg-ink/10" />
            ))}
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_320px]">
            <div>
                <div className="flex gap-2 border-b border-jade/15 pb-3">
                    {["Overview", "Hotels", "Restaurants", "Activities", "Itinerary"].map((t) => (
                        <div key={t} className="h-9 w-24 animate-pulse rounded-full bg-ink/10" />
                    ))}
                </div>
                <div className="mt-8 grid gap-6 sm:grid-cols-2">
                    {[0, 1, 2, 3].map((i) => (
                        <div key={i} className="overflow-hidden rounded-3xl bg-white ring-1 ring-jade/10">
                            <div className="aspect-[4/3] animate-pulse bg-ink/10" />
                            <div className="p-5 space-y-3">
                                <div className="h-7 w-3/4 animate-pulse rounded bg-ink/10" />
                                <div className="h-4 w-1/3 animate-pulse rounded bg-ink/10" />
                                <div className="h-4 w-full animate-pulse rounded bg-ink/10" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <aside className="rounded-3xl bg-white p-6 ring-1 ring-jade/10">
                <div className="h-3 w-1/3 animate-pulse rounded bg-ink/10" />
                <div className="mt-3 h-12 w-2/3 animate-pulse rounded bg-ink/10" />
                <div className="mt-2 h-3 w-1/2 animate-pulse rounded bg-ink/10" />
                <div className="mt-6 space-y-3">
                    {[0, 1, 2, 3, 4].map((i) => (
                        <div key={i} className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <div className="h-8 w-8 animate-pulse rounded-full bg-ink/10" />
                                <div className="h-3 w-24 animate-pulse rounded bg-ink/10" />
                            </div>
                            <div className="h-4 w-16 animate-pulse rounded bg-ink/10" />
                        </div>
                    ))}
                </div>
            </aside>
        </div>

        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50">
            <div className="glass flex items-center gap-3 rounded-full px-5 py-3 shadow-lg">
                <Loader2 size={16} className="animate-spin text-terracotta" />
                <PhaseTicker destination={destination} />
            </div>
        </div>
    </div>
);

export default ExploreSkeleton;
